import { ReactNode } from 'react';

type Props = {
  lineNumber: number;
  linesCount: number;
  showLineNumbers?: boolean;
  marker?: ReactNode;
  indentation?: ReactNode;
  content: ReactNode;
};

export const YamlLineBase = ({
  lineNumber,
  linesCount,
  showLineNumbers,
  marker,
  indentation,
  content,
}: Props) => {
  return (
    <div className="DsPreviewYaml-Line-root">
      {showLineNumbers && (
        <span className="DsPreviewYaml-Line-Index">
          <span className="DsPreviewYaml-Line-Index-LineNumber">
            {lineNumber}
          </span>
          <span className="DsPreviewYaml-Line-Index-MaxNumber">
            {linesCount}
          </span>
        </span>
      )}
      {marker}
      {indentation}
      <span className="DsPreviewYaml-Line-Content">{content}</span>
    </div>
  );
};
